import { render, staticRenderFns } from "./APINew.vue?vue&type=template&id=3c5cc14c&scoped=true&"
import script from "./APINew.vue?vue&type=script&lang=js&"
export * from "./APINew.vue?vue&type=script&lang=js&"
import style0 from "./APINew.vue?vue&type=style&index=0&id=3c5cc14c&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c5cc14c",
  null
  
)

export default component.exports